'use client';

import { useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

import IconSearch from '@/fo/icons/base/icons/search.svg';
import { UiKitInputSearch } from '@/fo/ui/kit/input/search';

export interface UiDoctorSearchBaseProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  placeholder?: string;
}

export function UiDoctorSearchBase({
  value,
  onChange,
  className,
  placeholder
}: UiDoctorSearchBaseProps) {
  const [internalValue, setInternalValue] = useState(value);

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const debouncedSearch = useDebouncedCallback((query: string) => {
    onChange(query);
  }, 300);

  const handleChange = (newValue: string) => {
    setInternalValue(newValue);
    debouncedSearch(newValue);
  };

  return (
    <UiKitInputSearch
      type="text"
      value={internalValue}
      onChange={(event) => handleChange(event.target.value)}
      placeholder={placeholder}
      startAdornment={<IconSearch />}
      className={className}
    />
  );
}
